// ============================================================================
// LISTA COMPLETA DE PAISES
// Codigos ISO 3166-1 alpha-2
// ============================================================================

export interface Country {
  name: string;
  code: string;  // ISO 3166-1 alpha-2 (MAYÚSCULA)
  flag?: string;
}

export const ALL_COUNTRIES: Country[] = [
  { name: 'Afganistán', code: 'AF', flag: '🇦🇫' },
  { name: 'Albania', code: 'AL', flag: '🇦🇱' },
  { name: 'Alemania', code: 'DE', flag: '🇩🇪' },
  { name: 'Andorra', code: 'AD', flag: '🇦🇩' },
  { name: 'Angola', code: 'AO', flag: '🇦🇴' },
  { name: 'Anguila', code: 'AI', flag: '🇦🇮' },
  { name: 'Antártida', code: 'AQ', flag: '🇦🇶' },
  { name: 'Antigua y Barbuda', code: 'AG', flag: '🇦🇬' },
  { name: 'Arabia Saudita', code: 'SA', flag: '🇸🇦' },
  { name: 'Argelia', code: 'DZ', flag: '🇩🇿' },
  { name: 'Argentina', code: 'AR', flag: '🇦🇷' },
  { name: 'Armenia', code: 'AM', flag: '🇦🇲' },
  { name: 'Aruba', code: 'AW', flag: '🇦🇼' },
  { name: 'Australia', code: 'AU', flag: '🇦🇺' },
  { name: 'Austria', code: 'AT', flag: '🇦🇹' },
  { name: 'Azerbaiyán', code: 'AZ', flag: '🇦🇿' },
  { name: 'Bahamas', code: 'BS', flag: '🇧🇸' },
  { name: 'Bahrein', code: 'BH', flag: '🇧🇭' },
  { name: 'Bangladesh', code: 'BD', flag: '🇧🇩' },
  { name: 'Barbados', code: 'BB', flag: '🇧🇧' },
  { name: 'Bélgica', code: 'BE', flag: '🇧🇪' },
  { name: 'Belice', code: 'BZ', flag: '🇧🇿' },
  { name: 'Benin', code: 'BJ', flag: '🇧🇯' },
  { name: 'Bermudas', code: 'BM', flag: '🇧🇲' },
  { name: 'Bielorrusia', code: 'BY', flag: '🇧🇾' },
  { name: 'Birmania', code: 'MM', flag: '🇲🇲' },
  { name: 'Bolivia', code: 'BO', flag: '🇧🇴' },
  { name: 'Bosnia y Herzegovina', code: 'BA', flag: '🇧🇦' },
  { name: 'Botsuana', code: 'BW', flag: '🇧🇼' },
  { name: 'Brasil', code: 'BR', flag: '🇧🇷' },
  { name: 'Brunei', code: 'BN', flag: '🇧🇳' },
  { name: 'Bulgaria', code: 'BG', flag: '🇧🇬' },
  { name: 'Burkina Faso', code: 'BF', flag: '🇧🇫' },
  { name: 'Burundi', code: 'BI', flag: '🇧🇮' },
  { name: 'Bután', code: 'BT', flag: '🇧🇹' },
  { name: 'Cabo Verde', code: 'CV', flag: '🇨🇻' },
  { name: 'Camboya', code: 'KH', flag: '🇰🇭' },
  { name: 'Camerún', code: 'CM', flag: '🇨🇲' },
  { name: 'Canadá', code: 'CA', flag: '🇨🇦' },
  { name: 'Chad', code: 'TD', flag: '🇹🇩' },
  { name: 'Chile', code: 'CL', flag: '🇨🇱' },
  { name: 'China', code: 'CN', flag: '🇨🇳' },
  { name: 'Chipre', code: 'CY', flag: '🇨🇾' },
  { name: 'Ciudad del Vaticano', code: 'VA', flag: '🇻🇦' },
  { name: 'Colombia', code: 'CO', flag: '🇨🇴' },
  { name: 'Comoras', code: 'KM', flag: '🇰🇲' },
  { name: 'Congo', code: 'CG', flag: '🇨🇬' },
  { name: 'Corea del Norte', code: 'KP', flag: '🇰🇵' },
  { name: 'Corea del Sur', code: 'KR', flag: '🇰🇷' },
  { name: 'Costa de Marfil', code: 'CI', flag: '🇨🇮' },
  { name: 'Costa Rica', code: 'CR', flag: '🇨🇷' },
  { name: 'Croacia', code: 'HR', flag: '🇭🇷' },
  { name: 'Cuba', code: 'CU', flag: '🇨🇺' },
  { name: 'Curazao', code: 'CW', flag: '🇨🇼' },
  { name: 'Dinamarca', code: 'DK', flag: '🇩🇰' },
  { name: 'Djibouti', code: 'DJ', flag: '🇩🇯' },
  { name: 'Dominica', code: 'DM', flag: '🇩🇲' },
  { name: 'Ecuador', code: 'EC', flag: '🇪🇨' },
  { name: 'Egipto', code: 'EG', flag: '🇪🇬' },
  { name: 'El Salvador', code: 'SV', flag: '🇸🇻' },
  { name: 'Emiratos Árabes Unidos', code: 'AE', flag: '🇦🇪' },
  { name: 'Eritrea', code: 'ER', flag: '🇪🇷' },
  { name: 'Eslovaquia', code: 'SK', flag: '🇸🇰' },
  { name: 'Eslovenia', code: 'SI', flag: '🇸🇮' },
  { name: 'España', code: 'ES', flag: '🇪🇸' },
  { name: 'Estados Unidos', code: 'US', flag: '🇺🇸' },
  { name: 'Estonia', code: 'EE', flag: '🇪🇪' },
  { name: 'Etiopía', code: 'ET', flag: '🇪🇹' },
  { name: 'Filipinas', code: 'PH', flag: '🇵🇭' },
  { name: 'Finlandia', code: 'FI', flag: '🇫🇮' },
  { name: 'Fiyi', code: 'FJ', flag: '🇫🇯' },
  { name: 'Francia', code: 'FR', flag: '🇫🇷' },
  { name: 'Gabón', code: 'GA', flag: '🇬🇦' },
  { name: 'Gambia', code: 'GM', flag: '🇬🇲' },
  { name: 'Georgia', code: 'GE', flag: '🇬🇪' },
  { name: 'Ghana', code: 'GH', flag: '🇬🇭' },
  { name: 'Gibraltar', code: 'GI', flag: '🇬🇮' },
  { name: 'Granada', code: 'GD', flag: '🇬🇩' },
  { name: 'Grecia', code: 'GR', flag: '🇬🇷' },
  { name: 'Groenlandia', code: 'GL', flag: '🇬🇱' },
  { name: 'Guadalupe', code: 'GP', flag: '🇬🇵' },
  { name: 'Guam', code: 'GU', flag: '🇬🇺' },
  { name: 'Guatemala', code: 'GT', flag: '🇬🇹' },
  { name: 'Guayana Francesa', code: 'GF', flag: '🇬🇫' },
  { name: 'Guernesey', code: 'GG', flag: '🇬🇬' },
  { name: 'Guinea', code: 'GN', flag: '🇬🇳' },
  { name: 'Guinea Ecuatorial', code: 'GQ', flag: '🇬🇶' },
  { name: 'Guinea-Bisáu', code: 'GW', flag: '🇬🇼' },
  { name: 'Guyana', code: 'GY', flag: '🇬🇾' },
  { name: 'Haití', code: 'HT', flag: '🇭🇹' },
  { name: 'Honduras', code: 'HN', flag: '🇭🇳' },
  { name: 'Hong Kong', code: 'HK', flag: '🇭🇰' },
  { name: 'Hungría', code: 'HU', flag: '🇭🇺' },
  { name: 'India', code: 'IN', flag: '🇮🇳' },
  { name: 'Indonesia', code: 'ID', flag: '🇮🇩' },
  { name: 'Irak', code: 'IQ', flag: '🇮🇶' },
  { name: 'Irán', code: 'IR', flag: '🇮🇷' },
  { name: 'Irlanda', code: 'IE', flag: '🇮🇪' },
  { name: 'Isla Bouvet', code: 'BV', flag: '🇧🇻' },
  { name: 'Isla de Man', code: 'IM', flag: '🇮🇲' },
  { name: 'Isla de Navidad', code: 'CX', flag: '🇨🇽' },
  { name: 'Isla Mauricio', code: 'MU', flag: '🇲🇺' },
  { name: 'Isla Norfolk', code: 'NF', flag: '🇳🇫' },
  { name: 'Islandia', code: 'IS', flag: '🇮🇸' },
  { name: 'Islas Åland', code: 'AX', flag: '🇦🇽' },
  { name: 'Islas Caimán', code: 'KY', flag: '🇰🇾' },
  { name: 'Islas Cocos', code: 'CC', flag: '🇨🇨' },
  { name: 'Islas Cook', code: 'CK', flag: '🇨🇰' },
  { name: 'Islas Feroe', code: 'FO', flag: '🇫🇴' },
  { name: 'Islas Georgias del Sur y Sándwich del Sur', code: 'GS', flag: '🇬🇸' },
  { name: 'Islas Heard y McDonald', code: 'HM', flag: '🇭🇲' },
  { name: 'Islas Malvinas', code: 'FK', flag: '🇫🇰' },
  { name: 'Islas Marianas del Norte', code: 'MP', flag: '🇲🇵' },
  { name: 'Islas Marshall', code: 'MH', flag: '🇲🇭' },
  { name: 'Islas Pitcairn', code: 'PN', flag: '🇵🇳' },
  { name: 'Islas Salomón', code: 'SB', flag: '🇸🇧' },
  { name: 'Islas Turcas y Caicos', code: 'TC', flag: '🇹🇨' },
  { name: 'Islas Vírgenes Británicas', code: 'VG', flag: '🇻🇬' },
  { name: 'Islas Vírgenes de EE.UU.', code: 'VI', flag: '🇻🇮' },
  { name: 'Israel', code: 'IL', flag: '🇮🇱' },
  { name: 'Italia', code: 'IT', flag: '🇮🇹' },
  { name: 'Jamaica', code: 'JM', flag: '🇯🇲' },
  { name: 'Japón', code: 'JP', flag: '🇯🇵' },
  { name: 'Jersey', code: 'JE', flag: '🇯🇪' },
  { name: 'Jordania', code: 'JO', flag: '🇯🇴' },
  { name: 'Kazajistán', code: 'KZ', flag: '🇰🇿' },
  { name: 'Kenia', code: 'KE', flag: '🇰🇪' },
  { name: 'Kirguistán', code: 'KG', flag: '🇰🇬' },
  { name: 'Kiribati', code: 'KI', flag: '🇰🇮' },
  { name: 'Kuwait', code: 'KW', flag: '🇰🇼' },
  { name: 'Laos', code: 'LA', flag: '🇱🇦' },
  { name: 'Lesoto', code: 'LS', flag: '🇱🇸' },
  { name: 'Letonia', code: 'LV', flag: '🇱🇻' },
  { name: 'Líbano', code: 'LB', flag: '🇱🇧' },
  { name: 'Liberia', code: 'LR', flag: '🇱🇷' },
  { name: 'Libia', code: 'LY', flag: '🇱🇾' },
  { name: 'Liechtenstein', code: 'LI', flag: '🇱🇮' },
  { name: 'Lituania', code: 'LT', flag: '🇱🇹' },
  { name: 'Luxemburgo', code: 'LU', flag: '🇱🇺' },
  { name: 'Macao', code: 'MO', flag: '🇲🇴' },
  { name: 'Macedonia del Norte', code: 'MK', flag: '🇲🇰' },
  { name: 'Madagascar', code: 'MG', flag: '🇲🇬' },
  { name: 'Malasia', code: 'MY', flag: '🇲🇾' },
  { name: 'Malaui', code: 'MW', flag: '🇲🇼' },
  { name: 'Maldivas', code: 'MV', flag: '🇲🇻' },
  { name: 'Malí', code: 'ML', flag: '🇲🇱' },
  { name: 'Malta', code: 'MT', flag: '🇲🇹' },
  { name: 'Marruecos', code: 'MA', flag: '🇲🇦' },
  { name: 'Martinica', code: 'MQ', flag: '🇲🇶' },
  { name: 'Mauritania', code: 'MR', flag: '🇲🇷' },
  { name: 'Mayotte', code: 'YT', flag: '🇾🇹' },
  { name: 'México', code: 'MX', flag: '🇲🇽' },
  { name: 'Micronesia', code: 'FM', flag: '🇫🇲' },
  { name: 'Moldavia', code: 'MD', flag: '🇲🇩' },
  { name: 'Mónaco', code: 'MC', flag: '🇲🇨' },
  { name: 'Mongolia', code: 'MN', flag: '🇲🇳' },
  { name: 'Montenegro', code: 'ME', flag: '🇲🇪' },
  { name: 'Montserrat', code: 'MS', flag: '🇲🇸' },
  { name: 'Mozambique', code: 'MZ', flag: '🇲🇿' },
  { name: 'Namibia', code: 'NA', flag: '🇳🇦' },
  { name: 'Nauru', code: 'NR', flag: '🇳🇷' },
  { name: 'Nepal', code: 'NP', flag: '🇳🇵' },
  { name: 'Nicaragua', code: 'NI', flag: '🇳🇮' },
  { name: 'Níger', code: 'NE', flag: '🇳🇪' },
  { name: 'Nigeria', code: 'NG', flag: '🇳🇬' },
  { name: 'Niue', code: 'NU', flag: '🇳🇺' },
  { name: 'Noruega', code: 'NO', flag: '🇳🇴' },
  { name: 'Nueva Caledonia', code: 'NC', flag: '🇳🇨' },
  { name: 'Nueva Zelanda', code: 'NZ', flag: '🇳🇿' },
  { name: 'Omán', code: 'OM', flag: '🇴🇲' },
  { name: 'Países Bajos', code: 'NL', flag: '🇳🇱' },
  { name: 'Palaos', code: 'PW', flag: '🇵🇼' },
  { name: 'Panamá', code: 'PA', flag: '🇵🇦' },
  { name: 'Papúa Nueva Guinea', code: 'PG', flag: '🇵🇬' },
  { name: 'Paquistán', code: 'PK', flag: '🇵🇰' },
  { name: 'Paraguay', code: 'PY', flag: '🇵🇾' },
  { name: 'Perú', code: 'PE', flag: '🇵🇪' },
  { name: 'Polinesia Francesa', code: 'PF', flag: '🇵🇫' },
  { name: 'Polonia', code: 'PL', flag: '🇵🇱' },
  { name: 'Portugal', code: 'PT', flag: '🇵🇹' },
  { name: 'Puerto Rico', code: 'PR', flag: '🇵🇷' },
  { name: 'Qatar', code: 'QA', flag: '🇶🇦' },
  { name: 'Reino Unido', code: 'GB', flag: '🇬🇧' },
  { name: 'República Centroafricana', code: 'CF', flag: '🇨🇫' },
  { name: 'República Checa', code: 'CZ', flag: '🇨🇿' },
  { name: 'República Democrática del Congo', code: 'CD', flag: '🇨🇩' },
  { name: 'República Dominicana', code: 'DO', flag: '🇩🇴' },
  { name: 'Reunión', code: 'RE', flag: '🇷🇪' },
  { name: 'Ruanda', code: 'RW', flag: '🇷🇼' },
  { name: 'Rumanía', code: 'RO', flag: '🇷🇴' },
  { name: 'Rusia', code: 'RU', flag: '🇷🇺' },
  { name: 'Sáhara Occidental', code: 'EH', flag: '🇪🇭' },
  { name: 'Samoa', code: 'WS', flag: '🇼🇸' },
  { name: 'Samoa Americana', code: 'AS', flag: '🇦🇸' },
  { name: 'San Bartolomé', code: 'BL', flag: '🇧🇱' },
  { name: 'San Cristóbal y Nieves', code: 'KN', flag: '🇰🇳' },
  { name: 'San Marino', code: 'SM', flag: '🇸🇲' },
  { name: 'San Martín', code: 'MF', flag: '🇲🇫' },
  { name: 'San Pedro y Miquelón', code: 'PM', flag: '🇵🇲' },
  { name: 'San Vicente y las Granadinas', code: 'VC', flag: '🇻🇨' },
  { name: 'Santa Elena', code: 'SH', flag: '🇸🇭' },
  { name: 'Santa Lucía', code: 'LC', flag: '🇱🇨' },
  { name: 'Santo Tomé y Príncipe', code: 'ST', flag: '🇸🇹' },
  { name: 'Senegal', code: 'SN', flag: '🇸🇳' },
  { name: 'Serbia', code: 'RS', flag: '🇷🇸' },
  { name: 'Seychelles', code: 'SC', flag: '🇸🇨' },
  { name: 'Sierra Leona', code: 'SL', flag: '🇸🇱' },
  { name: 'Singapur', code: 'SG', flag: '🇸🇬' },
  { name: 'Sint Maarten', code: 'SX', flag: '🇸🇽' },
  { name: 'Siria', code: 'SY', flag: '🇸🇾' },
  { name: 'Somalia', code: 'SO', flag: '🇸🇴' },
  { name: 'Sri Lanka', code: 'LK', flag: '🇱🇰' },
  { name: 'Suazilandia', code: 'SZ', flag: '🇸🇿' },
  { name: 'Sudáfrica', code: 'ZA', flag: '🇿🇦' },
  { name: 'Sudán', code: 'SD', flag: '🇸🇩' },
  { name: 'Sudán del Sur', code: 'SS', flag: '🇸🇸' },
  { name: 'Suecia', code: 'SE', flag: '🇸🇪' },
  { name: 'Suiza', code: 'CH', flag: '🇨🇭' },
  { name: 'Surinam', code: 'SR', flag: '🇸🇷' },
  { name: 'Svalbard y Jan Mayen', code: 'SJ', flag: '🇸🇯' },
  { name: 'Tailandia', code: 'TH', flag: '🇹🇭' },
  { name: 'Taiwán', code: 'TW', flag: '🇹🇼' },
  { name: 'Tanzania', code: 'TZ', flag: '🇹🇿' },
  { name: 'Tayikistán', code: 'TJ', flag: '🇹🇯' },
  { name: 'Territorio Británico del Océano Índico', code: 'IO', flag: '🇮🇴' },
  { name: 'Territorios Palestinos', code: 'PS', flag: '🇵🇸' },
  { name: 'Timor Oriental', code: 'TL', flag: '🇹🇱' },
  { name: 'Togo', code: 'TG', flag: '🇹🇬' },
  { name: 'Tokelau', code: 'TK', flag: '🇹🇰' },
  { name: 'Tonga', code: 'TO', flag: '🇹🇴' },
  { name: 'Trinidad y Tobago', code: 'TT', flag: '🇹🇹' },
  { name: 'Túnez', code: 'TN', flag: '🇹🇳' },
  { name: 'Turkmenistán', code: 'TM', flag: '🇹🇲' },
  { name: 'Turquía', code: 'TR', flag: '🇹🇷' },
  { name: 'Tuvalu', code: 'TV', flag: '🇹🇻' },
  { name: 'Ucrania', code: 'UA', flag: '🇺🇦' },
  { name: 'Uganda', code: 'UG', flag: '🇺🇬' },
  { name: 'Uruguay', code: 'UY', flag: '🇺🇾' },
  { name: 'Uzbekistán', code: 'UZ', flag: '🇺🇿' },
  { name: 'Vanuatu', code: 'VU', flag: '🇻🇺' },
  { name: 'Venezuela', code: 'VE', flag: '🇻🇪' },
  { name: 'Vietnam', code: 'VN', flag: '🇻🇳' },
  { name: 'Wallis y Futuna', code: 'WF', flag: '🇼🇫' },
  { name: 'Yemen', code: 'YE', flag: '🇾🇪' },
  { name: 'Zambia', code: 'ZM', flag: '🇿🇲' },
  { name: 'Zimbabue', code: 'ZW', flag: '🇿🇼' },
];
